import CarotekColors from "@carotek/utils/Colors";
import { breadcrumbStyles } from "@insite/content-library/Widgets/Basic/Breadcrumbs";
import { StyledButton } from "@insite/mobius/Clickable/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(breadcrumbStyles, {
    ...breadcrumbStyles,
    pageBreadcrumbs: {
        breadcrumbs: {
            css: css`
                padding-bottom: 10px;
                padding-top: 10px;
                flex-wrap: wrap;

                > [class^="TypographyStyle"] {
                    display: none;
                }

                > [class^="TypographyStyle"][aria-current="page"] {
                    display: inline;
                    position: relative;
                    font-size: 14px;

                    ::before {
                        content: "〱";
                        position: absolute;
                        left: -22px;
                        color: ${CarotekColors.grey1};
                        transform: rotate(-180deg);
                        font-size: 11px;
                        top: 2px;
                    }
                }

                > [class^="StyledButton"] {
                    margin-right: 35px;
                    position: relative;

                    > [class^="TypographyStyle"] {
                        font-size: 14px;
                    }

                    ::after {
                        content: "〱";
                        position: absolute;
                        right: -22px;
                        color: ${CarotekColors.grey1};
                        transform: rotate(-180deg);
                        font-size: 11px;
                    }

                    :last-of-type {
                        ::after {
                            display: none;
                        }
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                > [class^="TypographyStyle"] {
                                    display: none;
                                }

                                /* > [class^="TypographyStyle"][aria-current="page"] {
                                    display: none;
                                } */

                                > [class^="TypographyStyle"][aria-current="page"] {
                                    ::before {
                                        display: none;
                                    }
                                }

                                > [class^="StyledButton"] {
                                    display: none;

                                    :last-of-type {
                                        display: inline-flex;
                                        margin-right: 0;

                                        span {
                                            text-indent: -99999px;
                                        }

                                        ::before {
                                            content: "";
                                            display: inline-block;
                                            margin-right: 0.75rem !important;
                                            background-image: url("/userfiles/icons/carotek-breadcrumb-back-icon.svg");
                                            background-size: contain;
                                            background-repeat: no-repeat;
                                            width: 25px;
                                            height: 25px;
                                            filter: contrast(40%);
                                        }
                                    }
                                }
                            `,
                            css`
                                > [class^="TypographyStyle"] {
                                    display: none;
                                }

                                /* > [class^="TypographyStyle"][aria-current="page"] {
                                    display: none;
                                } */

                                > [class^="TypographyStyle"][aria-current="page"] {
                                    ::before {
                                        display: none;
                                    }
                                }

                                > [class^="StyledButton"] {
                                    display: none;

                                    :last-of-type {
                                        display: inline-flex;
                                        margin-right: 0;

                                        span {
                                            text-indent: -99999px;
                                        }

                                        ::before {
                                            content: "";
                                            display: inline-block;
                                            margin-right: 0.75rem !important;
                                            background-image: url("/userfiles/icons/carotek-breadcrumb-back-icon.svg");
                                            background-size: contain;
                                            background-repeat: no-repeat;
                                            width: 25px;
                                            height: 25px;
                                            filter: contrast(40%);
                                        }
                                    }
                                }
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
    },
});
